import { API_URL } from '../../../shared/actions'
import { customReducer } from '../customReducer'

export default function permissionReducer(state, action) {
  const {
    PERMISSION: { GET_ALL_PERMISSIONS, ADD_PERMISSION, EDIT_PERMISSION, GET_PERMISSION, DELETE_MANY_PERMISSION },
  } = API_URL

  // PERMISSIONS
  return customReducer(state, action, 'permissions', [GET_ALL_PERMISSIONS, ADD_PERMISSION, EDIT_PERMISSION, GET_PERMISSION, DELETE_MANY_PERMISSION])
}
